export const envProduction = {
  API_URL: 'https://pombeebee.com/',
  SERVER_URL: 'https://pombeebee.com/',
  SOCKET_URL: 'https://pombeebee.com',
  ENV: 'production',
  STRIPE_KEY:
    'pk_live_51J50roHS6YSYjau7nz9jJR4Cfs86J5QGK9SW3kUJgjMdM3v6tP5D6UQIA5WVz0Z2xTSort5PvlfkT4iSulhoQkwA00SyzxNg5m',
};
